module.exports = __webpack_public_path__ + "static/media/hexagon-hiw-register.1f32f5fa.svg";